import { ChevronDownIcon, Flex, Text } from '@radix-ui/themes'
import { Accordion as RadixAccordion } from 'radix-ui'
import { JSX } from 'react'
import './accordion.scss'

export type AccordionItems = {
  id: string
  value: string
  name?: string
  actionButton?: JSX.Element
  child: JSX.Element
}
export type AccordionProps = {
  items: AccordionItems[]
  values?: string[]
  onValueChange?: (values: string[]) => void
}

export const Accordion = ({ items, onValueChange, values }: AccordionProps) => {
  const accordianItems = items.map((item) => {
    return (
      <RadixAccordion.Item key={item.id} value={item.value}>
        {item.name ? (
          <Flex className="AccordionRow">
            <RadixAccordion.Header className="AccordionHeader">
              <RadixAccordion.Trigger className="AccordionTrigger">
                <Text>{item.name}</Text>
                <ChevronDownIcon className="AccordionChevron" aria-hidden />
              </RadixAccordion.Trigger>
            </RadixAccordion.Header>
            {/* Beside the heading, not inside it: a button can't contain other interactive controls, and anything in
                the heading becomes part of its accessible name */}
            {item.actionButton ? (
              <Flex className="AccordionActions" align="center" gap="6">
                {item.actionButton}
              </Flex>
            ) : null}
          </Flex>
        ) : null}
        {item.child}
      </RadixAccordion.Item>
    )
  })

  return (
    <RadixAccordion.Root type="multiple" value={values} onValueChange={onValueChange}>
      {accordianItems}
    </RadixAccordion.Root>
  )
}
